var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('h1',[_vm._v("Settings"),(_vm.sub)?_c('span',[_vm._v(": "+_vm._s(_vm.sub))]):_vm._e()])]),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_vm._t("default",[(_vm.showButtons)?_c('SettingsButtons',{attrs:{"saving":_vm.saving,"show-save":_vm.showSave,"show-cancel":_vm.showCancel}}):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a4bf8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SettingsTitleBar.vue
// module id = +Anf
// module chunks = 1